import React, { memo } from 'react'

import { FileTypeGroup, FileTypesByGroup } from '../constants'

import { SupportedFilesModal } from './SupportedFilesModal'

interface SupportedSpreadsheetFilesModalProps {
  hideModal: () => void
}

export const SupportedSpreadsheetFilesModal = memo(
  (props: SupportedSpreadsheetFilesModalProps) => (
    <SupportedFilesModal
      {...props}
      {...{
        fileTypes: FileTypesByGroup[FileTypeGroup.SPREADSHEET],
      }}
    />
  ),
)
